import { ReactNode } from "react";
import { AppDrawer } from "./AppDrawer";
import { useLanguage } from "@/contexts/LanguageContext";
import { scrollToTop } from "./BackToTopButton";

interface AppHeaderProps {
  showDrawerTrigger?: boolean;
  title?: string;
  rightActions?: ReactNode;
}

export const AppHeader = ({ 
  showDrawerTrigger = true, 
  title,
  rightActions 
}: AppHeaderProps) => {
  const { t } = useLanguage();
  const displayTitle = title || t('app.name');
  
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/95 backdrop-blur border-b">
      <div className="container mx-auto px-4 py-3 flex items-center justify-between gap-2">
        <div className="flex items-center gap-2.5 min-w-0 flex-1">
          {showDrawerTrigger && <AppDrawer />}
          <button
            onClick={scrollToTop}
            className="flex items-center min-w-0 hover:opacity-80 active:scale-[0.98] transition-all cursor-pointer"
            aria-label="Scroll to top"
          >
            <h1 className="text-xl font-bold truncate">{displayTitle}</h1>
          </button>
        </div>
        {rightActions && (
          <div className="flex gap-2 items-center flex-shrink-0">
            {rightActions}
          </div>
        )}
      </div>
    </header>
  );
};
